import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IMyMonitoringAccountModel, IMyMonitoringAccountUnitItemModel } from '@apps-common/types/portal/my-monitoring'

export const createMyMonitoringAccount = async (
  account: IMyMonitoringAccountModel,
  units: IMyMonitoringAccountUnitItemModel[]
): Promise<IMyMonitoringAccountModel> =>
  axios.post(`/MyMonitoringAccountManagement/CreateAccount`, { account, units }).then((res) => res?.data?.data)

type Props = {
  account: IMyMonitoringAccountModel
  units: IMyMonitoringAccountUnitItemModel[]
}

export const useCreateMyMonitoringAccount = (notify?: boolean, onSuccess?: (data: IMyMonitoringAccountModel) => void) =>
  useMutation({
    mutationKey: ['createMyMonitoringAccount'],
    mutationFn: ({ account, units }: Props) => createMyMonitoringAccount(account, units),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Account created.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to create account.')
      }
    },
    throwOnError: false
  })
